import {svgIconWrapper} from '../svg-icon-wrapper';

import ChartLineRegular from './chart-line-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ChartLineRegular {...props} />;
}
SvgComponent.iconName = 'chartLineRegular';

export const ChartLineRegularIcon = svgIconWrapper(SvgComponent);
